import styled from "styled-components";
export const StyledPagesClientSearchFilters = styled.div`
  .rbt-token-removeable {
    cursor: pointer;
  }
  .rbt-token .rbt-token-label {
    padding: 0.25rem 0.5rem;
  }

  .rbt-token .rbt-token-label:not(:last-child) {
    padding-right: 0.25rem;
  }

  .rbt-token .rbt-token-remove-button {
    background-image: none;
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
    box-shadow: none;
    color: inherit;
    font-size: inherit;
    font-weight: 400;
    justify-content: center;
    opacity: 1;
    outline: none;
    padding: 0.25rem 0.5rem 0.25rem 0;
    text-shadow: none;
  }

  .rbt-token .rbt-token-remove-button .rbt-close-content {
    display: block;
  }

  .rbt-token {
    background-color: #e7f4ff;
    border: 0;
    border-radius: 0.25rem;
    color: #007bff;
    display: inline-flex;
    line-height: 1rem;
    margin: 1px 3px 2px 0;
  }
`;
